import Link from "next/link";
import React, { useState } from "react";

export default function CaseStudies({ casestudies }) {

  const blogsortByDateCreated = casestudies.sort((a, b) => {
    return new Date(b.date) - new Date(a.date);
  });
  const blogFiltered = blogsortByDateCreated.filter((data) => {
    return data.tags?.includes("open-data")
  })
  const [blogsFetched, setBlogsFetched] = useState(blogFiltered.slice(0, 3));

  return (
    <div className="bg-white font-['Inter']">
      <div className="max-w-8xl px-8">
        <div className="flex flex-col items-start justify-start gap-4 pb-8 w-full" tabIndex={0}>
          <div className="medium-title text-left pt-14">
            Read our case studies
          </div>
          <p className="body-text pt-2 md:text-left"> Learn more about our work with clients and partners, such as specific scenarios and challenges we overcame, and more.
          </p>
        </div>
        <div className=" mt-6 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {blogsFetched.map((post) => (
            <article key={post.urlPath} className="flex flex-col items-start " tabIndex={0}>
              <div className="relative w-full">
                <img
                  src={`${post?.image ? post.image: "/assets/images/layout/datopian-logo-black.png"}`}
                  alt="Datopian logo"
                  className="aspect-[16/9] w-full rounded-2xl bg-gray-100 object-cover sm:aspect-[2/1] lg:aspect-[3/2]"
                />
                <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />
              </div>
              <div className="max-w-xl">
                <div className="mt-8 flex items-center gap-x-4 text-xs">
                  <span className="text-gray-500">
                    {post?.readingTime ? post.readingTime + " min read" : "0 min read"}
                  </span>
                  <div
                    className="relative z-10 rounded-full bg-gray-50 px-3 py-1.5 font-medium text-gray-600 hover:bg-gray-100 capitalize"
                  >
                    {post.industries[0]}
                  </div>
                </div>
                <div className="group relative">
                  <h3 className="mt-3 text-lg font-bold text-start text-gray-900 group-hover:text-orange-400 line-clamp-1">
                    <Link href={`../${post.urlPath}`}>
                      <span className="absolute inset-0" />
                      {post.title}
                    </Link>
                  </h3>
                  <p className="mt-5 line-clamp-3  text-start body-text">{post.description || post.brief}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  )
}
